var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeftCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9797 30.4805C24.264 30.4805 30.9797 23.7647 30.9797 15.4805C30.9797 7.1962 24.264 0.480469 15.9797 0.480469C7.69545 0.480469 0.979721 7.1962 0.979721 15.4805C0.979721 23.7647 7.69545 30.4805 15.9797 30.4805ZM29.4797 15.4805C29.4797 22.9363 23.4356 28.9805 15.9797 28.9805C8.52388 28.9805 2.47972 22.9363 2.47972 15.4805C2.47972 8.02462 8.52388 1.98047 15.9797 1.98047C23.4356 1.98047 29.4797 8.02462 29.4797 15.4805ZM16.7071 10.9571C17.0976 10.5666 17.0976 9.93342 16.7071 9.54289C16.3166 9.15237 15.6834 9.15237 15.2929 9.54289L10.0429 14.7929C9.65237 15.1834 9.65237 15.8166 10.0429 16.2071L15.2929 21.4571C15.6834 21.8476 16.3166 21.8476 16.7071 21.4571C17.0976 21.0666 17.0976 20.4334 16.7071 20.0429L13.1598 16.4956H21.26C21.6528 16.4956 22.2203 16.2071 22.2203 15.4018C22.2203 14.7576 21.5801 14.5351 21.26 14.5044H13.1598L16.7071 10.9571Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftCircle);
export default __webpack_public_path__ + "static/media/ArrowLeftCircle.7a4d23ca9fca59958d28e3a8001adaa9.svg";
export { ForwardRef as ReactComponent };